// extracted by mini-css-extract-plugin
export default {"input":"Input_input__mSo5v","sub":"Input_sub__gDMcU"};